// extracted by mini-css-extract-plugin
module.exports = {"timePicker":"style_timePicker__3QHl5","digit":"style_digit__2psjf"};